// @flow

import { setCartOwner, selectCartHasOrga } from '@gandi/cart';
import type { TranslatorProps } from '@gandi/translate';

import {
  updateCartProductOwner,
  updateProductsPayload,
  updateCartConfigurationForOwnership,
} from 'src/Cart/AccountChoice/modules/actions';
import { applyTemplateIfNeeded } from 'src/modules/app/actions';
import type { Dispatch, GetState, ThunkAction } from 'src/types';

import { selectNavigationMode } from './selectNavigationMode';

type submitAccountChoiceParams = {
  translator: TranslatorProps,
  displayNewAccountChoice: boolean,
};

export const accountChoiceSubmit =
  ({
    translator,
    displayNewAccountChoice,
  }: submitAccountChoiceParams): ThunkAction<Promise<void>> =>
  async (dispatch: Dispatch, getState: GetState) => {
    const mode = selectNavigationMode(getState());
    const cartHasOrga = selectCartHasOrga(getState());

    await dispatch(applyTemplateIfNeeded());

    // Sync product owner if not handled by new UI or if configuring
    if (!displayNewAccountChoice || mode === 'configure') {
      await dispatch(updateCartProductOwner());
    }

    if (mode === 'continue')
      await dispatch(updateProductsPayload({ translator }));
    else await dispatch(updateCartConfigurationForOwnership());

    // Reset invoiced organization conditionally
    if (
      mode === 'configure' ||
      !displayNewAccountChoice ||
      (displayNewAccountChoice && !cartHasOrga)
    ) {
      try {
        await dispatch(setCartOwner({}));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    }
  };
